'use client';

import './index.css';

import { storyblokEditable } from '@storyblok/react';
import classnames from 'classnames';

import { Button } from '@/components/button';
import { MaxWidth } from '@/components/max-width';

import { hasText, render } from '@/helpers/storyblok/rich-text';
import { markdownToHtml } from '@/helpers/string';

const parseBulletList = (value) => {
  if (typeof value !== 'string') return [];
  return value
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
};

export const HeroClient = ({ blok }) => {
  const TitleEl = blok.titleLevel || 'h1';
  const bullets = parseBulletList(blok.bulletList);

  return (
    <div
      {...storyblokEditable(blok)}
      className={classnames('hero', `hero--align-${blok.align || 'center'}`)}
    >
      <MaxWidth className="hero__content">
        <TitleEl
          className="hero__title"
          dangerouslySetInnerHTML={{
            __html: markdownToHtml(blok.title),
          }}
        />

        {hasText(blok.description) ? (
          <div className="hero__description">{render(blok.description)}</div>
        ) : null}

        {bullets.length > 0 ? (
          <ul className="hero__bullets">
            {bullets.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        ) : null}

        {blok.cta?.length > 0 ? (
          <div className="hero__cta">
            {(blok.cta || []).map((link) => {
              return (
                <Button
                  key={link._uid}
                  {...storyblokEditable(link)}
                  link={link.link}
                  theme={link.theme || 'primary'}
                >
                  {link.title}
                </Button>
              );
            })}
          </div>
        ) : null}
      </MaxWidth>
    </div>
  );
};
